import Loadable from 'react/components/loadable';

const InvoicePlanMembershipRealignmentConfirmationModal = Loadable({
  loader: () =>
    import(
      '../../../pages/contacts/memberships/invoice_plan_memberships/invoice_plan_membership_realignment_confirmation_modal'
    ),
});

angular
  .module('gym')
  .value(
    'InvoicePlanMembershipRealignmentConfirmationModal',
    InvoicePlanMembershipRealignmentConfirmationModal,
  );
